import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import { ImageIcon, EmbedIcon, DlIcon, CloseIcon, FilePDFIcon, ExternalLinkIcon } from '../../../../components/Icons';
import onDownload from '../utils/onDownload';
import TooltipOnHover from '../../../../components/TooltipOnHover';
import { fetchOEmbed } from '../../../../components/Embed/utils';
import BlockTypes from '../../../../types/BlockTypes';

var Topbar =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Topbar, _React$Component);

  function Topbar() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Topbar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Topbar)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      subtitle: '',
      title: '',
      Icon: ImageIcon,
      url: ''
    });

    return _this;
  }

  _createClass(Topbar, [{
    key: "getImageAuthorName",
    value: function getImageAuthorName(_ref) {
      var createdBy = _ref.createdBy;
      var user = this.props.getUser ? this.props.getUser(createdBy) : undefined;
      return user ? user.displayName : 'someone';
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.getMetaInformations(this.props.mediaData);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unmounted = true;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.mediaData.url !== this.props.mediaData.url) {
        this.getMetaInformations(this.props.mediaData);
      }
    }
  }, {
    key: "getMetaInformations",
    value: function getMetaInformations(item) {
      var _this2 = this;

      var mediaType = item.type,
          size = item.size,
          name = item.name,
          createdBy = item.createdBy,
          iframelyApiKey = item.iframelyApiKey,
          url = item.url;
      var isEmbed = mediaType === BlockTypes.EMBED;
      var isImage = mediaType === BlockTypes.IMAGE;

      if (!isEmbed) {
        var authorName = this.getImageAuthorName({
          createdBy: createdBy
        });
        var subtitle = authorName ? "".concat(size, " - uploaded by ").concat(authorName) : size;
        var title = name ? name : "Media ".concat(this.props.index + 1);
        this.setState({
          subtitle: subtitle,
          title: title,
          Icon: isImage ? React.createElement(ImageIcon, {
            size: 16
          }) : React.createElement(FilePDFIcon, {
            size: 16,
            className: "red"
          })
        });
      } else {
        fetchOEmbed({
          url: url,
          iframelyApiKey: iframelyApiKey
        }).then(function (_ref2) {
          var meta = _ref2.meta;

          if (_this2.unmounted || !meta) {
            return;
          }

          var title = meta.title,
              provider = meta.site;

          _this2.setState({
            title: title,
            subtitle: provider,
            Icon: EmbedIcon
          });
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          onToggle = _this$props.onToggle,
          mediaData = _this$props.mediaData;
      var _this$state = this.state,
          title = _this$state.title,
          subtitle = _this$state.subtitle,
          Icon = _this$state.Icon;
      var isImage = mediaData.type === BlockTypes.IMAGE;
      var isPDF = mediaData.type === BlockTypes.PDF;
      return React.createElement("div", {
        className: "flexbox flexbox-no-shrink flexbox-align-center background-white shade-05"
      }, React.createElement("div", {
        className: "shade-20 padding-medium"
      }, Icon), React.createElement("div", {
        className: "flexbox-grow padding-vertical-medium padding-right-medium"
      }, React.createElement("div", {
        className: "font-weight-bold padding-bottom-smaller"
      }, title), React.createElement("div", {
        className: "shade-20 font-size-smaller"
      }, subtitle)), React.createElement("div", {
        className: "flexbox flexbox-align-center"
      }, isImage && React.createElement(TooltipOnHover, {
        id: "download",
        placement: "left",
        tooltipContent: "Download"
      }, React.createElement("div", {
        className: "pointer shade-30 shade-10-on-hover padding-medium",
        onClick: function onClick(event) {
          onDownload(event, {
            url: mediaData.url
          });
        }
      }, React.createElement(DlIcon, {
        size: 16
      }))), isPDF && React.createElement(TooltipOnHover, {
        id: "original",
        placement: "left",
        tooltipContent: "View original"
      }, React.createElement("div", {
        className: "pointer shade-30 shade-10-on-hover padding-medium",
        onClick: function onClick(event) {
          onDownload(event, {
            url: mediaData.url
          });
        }
      }, React.createElement(ExternalLinkIcon, {
        size: 16
      }))), React.createElement("div", {
        className: "background-shade-50",
        style: {
          width: 1,
          height: 20
        }
      }), React.createElement(TooltipOnHover, {
        id: "close",
        placement: "left",
        tooltipContent: "Close"
      }, React.createElement("div", {
        className: "pointer shade-30 shade-10-on-hover padding-medium",
        onClick: onToggle
      }, React.createElement(CloseIcon, {
        size: 14,
        style: {
          verticalAlign: '-2px'
        }
      })))));
    }
  }]);

  return Topbar;
}(React.Component);

export default Topbar;